/**
 * 랜드마크 SPOT 적립 CITY 보너스 — CityModal getTotalBonus와 동일 규칙.
 * @param {Array<{ cityId?: string }|null|undefined>} slots equippedList 또는 장착 토큰 배열
 * @returns {number} 합산 보너스 (% 포인트, 예: 15 = 15%)
 */
export function sumCityLandmarkSpotBonusPercent(slots) {
  if (!Array.isArray(slots)) return 0;
  let bonus = 0;
  for (const item of slots) {
    if (!item || !item.cityId) continue;
    bonus += item.cityId === 'city_genesis' ? 10 : 5;
  }
  return bonus;
}

/** SPOT 적립 배율 (15% → 1.15) */
export function cityLandmarkBonusMultiplier(slots) {
  const p = sumCityLandmarkSpotBonusPercent(slots);
  return p > 0 ? 1 + p / 100 : 1;
}
